.diff {
    span {
        box-sizing: content-box;
    }

    ul {
        margin: 0;
        padding-inline-start: calc(0.75 * 1.25em + 0.5em + 2px);
        position: relative;

        ul {
            margin-top: 0.25em;

            &::before {
                content: '';
                position: absolute;
                top: 0.1875em;
                bottom: 1em;
                left: 0;
            }
        }
    }

    .node {
        padding: 0.1875em 0;
        line-height: 1em;

        &.hover > ul::before {
            border-left: 1px solid #ddd;
            z-index: 1;
        }

        &.object,
        &.array {
            position: relative;
            list-style-type: disclosure-open;
            
            &.collapsed {
                list-style-type: disclosure-closed;
        
                > ul {
                    display: none;
                }
        
                > .property::after {
                    content: '';
                }
            }
        }

        &.leaf {
            display: flex;
            align-items: flex-start;
            column-gap: 0.5em;
            
            &::before {
                content: '';
                position: absolute;
                display: block;
                width: 1em;
                height: 0.5em;
                left: 0;
                color: #ddd;
            }
            
            &:hover::before {
                border-left: 1px solid;
                border-bottom: 1px solid;
            }
        }

        > .type {
            text-transform: uppercase;
            color: white;
            font-size: 0.75em;
            font-weight: bold;
            padding: 2px 4px;
            border-radius: 3px;
            transform: translateY(-2px);
        }

        &.removed > .type {
            background-color: red;
        }

        &.added > .type {
            background-color: green;
        }

        &.new > .type {
            background-color: blue;
        }

        &.unchanged > .type {
            background-color: grey;
        }

        &.updated > .type {
            background-color: darkorange;
        }

        > .property {
            font-style: italic;
            color: grey;

            &::after {
                content: ':';
            }
        }

        &.array > ul > .node > .property {
            display: inline-block;
            line-height: 1em;
            width: 1em;
            height: 1em;
            padding: 0.125em;
            border: 1px solid;
            border-radius: 50%;
            text-align: center;
            font-size: 0.75em;
            font-style: normal;
            flex-shrink: 0;

            &::after {
                content: '';
            }
        }

        > .value {
            > .content {
                font-size: 0.9375em;
            }
            
            &.old > .content {
                text-decoration: line-through;
            }

            &.new > .content {
                color: blue;
            }

            > .list {
                &::before {
                    content: '[ ';
                }

                &::after {
                    content: ' ]';
                }

                > span + span::before {
                    content: ', '
                }
            }
        }

        > .toggle-handler {
            position: absolute;
            display: block;
            top: -0.125em;
            left: calc(0.75 * -1.25em - 0.5em - 2px);
            right: 0;
            height: 1.125em;
            margin: 0.125em 0;
            padding: 0.125em 0;
            border-radius: 2px;
            cursor: pointer;

            &:hover::after {
                content: attr(data-hint);
                position: absolute;
                right: 0;
                font-size: 0.65em;
                color: #888;
            }
        }

        .placeholder {
            color: white;
            font-size: 0.7em;
            font-weight: 600;
            font-family: monospace;
            text-transform: uppercase;
            padding: 0 4px;
            border-radius: 4px;
        
            &.empty {
                background-color: #ccc;
            }
            
            &.truncated {
                background-color: #ccc;
            }
            
            &.object {
                background-color: #222;
            }
        }
    }
}

.preview {
    display: none;
    position: absolute;
    z-index: 1;
    background: #fff;
    transform: translateY(-1.5em);
    padding: 0.5em 1em;
    box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.15);
    font-size: 0.8em;
}

.preview:hover,
.object.placeholder:hover + .preview {
    display: block;
}
